module.exports = __webpack_public_path__ + "static/media/Donna Auger Headshot_1591180091909.c51414be.png";